module.exports = __webpack_public_path__ + "img/general_nylogo_website.1cf9a020.svg";